var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "17.233%",
    x2: "119.661%",
    y1: "-86.102%",
    y2: "264.38%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0FCE7C"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 29.787,
    cy: 29.787,
    r: 29.787
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "url(#b)",
    strokeWidth: 3,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00C4B3",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M29.886 31.161h.203c1.853-.03 3.352-.67 4.46-1.894 2.435-2.696 2.03-7.317 1.986-7.758-.158-3.31-1.753-4.894-3.068-5.633-.98-.553-2.126-.851-3.404-.876H29.956c-.702 0-2.082.112-3.404.85-1.328.74-2.948 2.324-3.106 5.66-.044.44-.449 5.061 1.987 7.757 1.1 1.224 2.6 1.863 4.453 1.894zm-4.75-9.496c0-.019.006-.038.006-.05.208-4.454 3.428-4.932 4.807-4.932h.076c1.708.037 4.612.72 4.808 4.932 0 .019 0 .037.006.05.007.043.45 4.267-1.562 6.49-.797.882-1.86 1.317-3.258 1.33h-.063c-1.392-.013-2.461-.448-3.252-1.33-2.005-2.21-1.575-6.453-1.569-6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.987 38.826v-.019c0-.05-.006-.099-.006-.155-.038-1.23-.12-4.105-2.866-5.025l-.063-.018c-2.853-.715-5.225-2.33-5.25-2.348a.863.863 0 0 0-1.19.205.828.828 0 0 0 .209 1.168c.107.074 2.625 1.795 5.776 2.59 1.474.515 1.638 2.062 1.682 3.478 0 .056 0 .105.007.155.006.56-.032 1.423-.133 1.92-1.025.57-5.042 2.546-11.153 2.546-6.086 0-10.128-1.981-11.16-2.553-.1-.497-.145-1.36-.132-1.92 0-.049.006-.098.006-.154.045-1.416.21-2.963 1.683-3.479 3.15-.795 5.668-2.521 5.776-2.59a.828.828 0 0 0 .209-1.167.863.863 0 0 0-1.19-.205c-.025.018-2.385 1.633-5.25 2.347a.808.808 0 0 0-.064.02c-2.745.925-2.827 3.8-2.865 5.024 0 .056 0 .106-.007.155v.019c-.006.323-.012 1.981.323 2.814a.8.8 0 0 0 .329.39c.19.125 4.738 2.97 12.348 2.97s12.159-2.851 12.349-2.97a.835.835 0 0 0 .329-.39c.316-.827.31-2.485.303-2.808z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.8d1e9f509b2e31ee426b78dfcf4e7d53.svg";
export { ForwardRef as ReactComponent };